<template>
	<el-footer>
		<div class="footer">
			<div class="nameClass">{{ $t('system.footData.Name') }}</div>
			<div class="infoClass">
				{{ $t('system.footData.ContactUs') }}：lpdc@nao.cas.cn &nbsp;&nbsp;&nbsp; {{ $t('system.footData.RecordNumber') }}：京ICP备05002854-1号 &nbsp;&nbsp;&nbsp;{{
					$t('system.footData.WenbaoNetworkSecurityFilingNumber')
				}}：1101050056
			</div>
		</div>
	</el-footer>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	components: {},
	data() {
		return {}
	},
	computed: {},
	methods: {}
}
</script>

<style lang="scss" scoped>
.footer {
	width: 100%;
	// background: #BCC8DA;
	text-align: center;
	height: 80px;
	// background-size: cover;
	// 			background: url('~@/assets/imgs/newHome/bgBom.png');
	// 			background-size: 100% 100%;
	// 			background-repeat: no-repeat;
	display: flex;
	justify-content: center;
	flex-direction: column;
	background: rgba(255, 255, 255, 0.5);
	box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.1);
	.nameClass {
		// font-family: MicrosoftYaHeiUISemilight;
		font-size: 14px;
		color: #666666;
		letter-spacing: 0;
		font-weight: 300;
	}
	.infoClass {
		// font-family: MicrosoftYaHeiUISemilight;
		font-size: 12px;
		color: #666666;
		letter-spacing: 0;
		font-weight: 300;
	}
}
</style>